import {
    initCarouselsForLargeShopPromos,
    initCinemasForSmallShopPromos,
    initPromoBrandShopPromo
} from './init';
import { Logger } from "./logger";

window.o_global.eventQBus.on("ft3.promo-shoppromo.large-init", (featureIndex) => {
    Logger.group("[FT3 promo shoppromo]");
    Logger.count("Large Shoppromo Invocation");
    initCarouselsForLargeShopPromos(featureIndex);
    Logger.groupEnd();
});

window.o_global.eventQBus.on("ft3.promo-shoppromo.small-init", (featureIndex) => {
    Logger.group("[FT3 promo shoppromo]");
    Logger.count("Small Shoppromo Invocation");
    initCinemasForSmallShopPromos(featureIndex);
    Logger.groupEnd();
});

window.o_global.eventQBus.on("ft3.promo-shoppromo.brand-init", () => {
    Logger.group("[FT3 promo shoppromo]");
    Logger.count("Brand Shoppromo Invocation");
    initPromoBrandShopPromo();
    Logger.groupEnd();
});

Logger.log("Module ft3.promo.shoppromo is loaded and init listeners are registered");